// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"066c0cb8d25b77f9","6831":"1765408c259e5e61","8503":"ea048072fb355d09","9683":"f38b6a73a2408460"}[chunkId] + ".js";
};